module.exports = __webpack_public_path__ + "img/HZGB02-02-04.d7a8c6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB02-02-04.png
// module id = EF1f
// module chunks = 0